module.exports = __webpack_public_path__ + "media/nom-landing/nom-steps-1-3bf85b91.png";